import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CandidateMatchCard from '../components/CandidateMatchCard';
import { Candidate } from '../types';

// Mock data - REPLACE WITH ACTUAL API CALL
const MOCK_ALL_CANDIDATES: Candidate[] = [
    // Row 1
    {
        id: '1',
        name: 'Sara El-Masry',
        jobTitle: 'Senior Product Designer',
        experience: '5+ years experience at SaaS companies',
        location: 'UAE',
        country: 'United Arab Emirates',
        countryCode: 'AE',
        matchScore: 91,
        avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b1c5?w=150&h=150&fit=crop&crop=face'
    },
    {
        id: '2',
        name: 'Andre Collins',
        jobTitle: 'UX/UI Designer',
        experience: 'Experience in B2B dashboard interfaces',
        location: 'Germany',
        country: 'Germany',
        countryCode: 'DE',
        matchScore: 87,
        avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
    },
    {
        id: '3',
        name: 'Aisha Khan',
        jobTitle: 'UX Researcher',
        experience: 'Full Time • $30K-$35K',
        location: 'India',
        country: 'India',
        countryCode: 'IN',
        matchScore: 77,
        avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face'
    },
    // Row 2 - Duplicated for demo (Replace with actual different candidates)
    {
        id: '4',
        name: 'Sara El-Masry',
        jobTitle: 'Senior Product Designer',
        experience: '5+ years experience at SaaS companies',
        location: 'UAE',
        country: 'United Arab Emirates',
        countryCode: 'AE',
        matchScore: 91,
        avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b1c5?w=150&h=150&fit=crop&crop=face'
    },
    {
        id: '5',
        name: 'Andre Collins',
        jobTitle: 'UX/UI Designer',
        experience: 'Experience in B2B dashboard interfaces',
        location: 'Germany',
        country: 'Germany',
        countryCode: 'DE',
        matchScore: 87,
        avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
    },
    {
        id: '6',
        name: 'Aisha Khan',
        jobTitle: 'UX Researcher',
        experience: 'Full Time • $30K-$35K',
        location: 'India',
        country: 'India',
        countryCode: 'IN',
        matchScore: 77,
        avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face'
    },
    // Row 3 - Duplicated for demo (Replace with actual different candidates)
    {
        id: '7',
        name: 'Sara El-Masry',
        jobTitle: 'Senior Product Designer',
        experience: '5+ years experience at SaaS companies',
        location: 'UAE',
        country: 'United Arab Emirates',
        countryCode: 'AE',
        matchScore: 91,
        avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b1c5?w=150&h=150&fit=crop&crop=face'
    },
    {
        id: '8',
        name: 'Andre Collins',
        jobTitle: 'UX/UI Designer',
        experience: 'Experience in B2B dashboard interfaces',
        location: 'Germany',
        country: 'Germany',
        countryCode: 'DE',
        matchScore: 87,
        avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face'
    },
    {
        id: '9',
        name: 'Aisha Khan',
        jobTitle: 'UX Researcher',
        experience: 'Full Time • $30K-$35K',
        location: 'India',
        country: 'India',
        countryCode: 'IN',
        matchScore: 77,
        avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face'
    }
];

const AllRecommendations: React.FC = () => {
    const navigate = useNavigate();
    const [candidates, setCandidates] = useState<Candidate[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    
    const candidatesPerPage = 9; // 3x3 grid
    const totalPages = Math.ceil(MOCK_ALL_CANDIDATES.length / candidatesPerPage);

    // BACKEND INTEGRATION POINT - Replace with actual API call
    useEffect(() => {
        const fetchAllCandidates = async () => {
            setLoading(true);
            try {
                // TODO: Replace with actual API call with pagination
                // const response = await fetch(`/api/candidates/all?page=${currentPage}&limit=${candidatesPerPage}`);
                // const data = await response.json();
                
                // Mock API delay
                await new Promise(resolve => setTimeout(resolve, 500));
                
                // Simulate pagination
                const startIndex = (currentPage - 1) * candidatesPerPage;
                const endIndex = startIndex + candidatesPerPage;
                const paginatedCandidates = MOCK_ALL_CANDIDATES.slice(startIndex, endIndex);
                
                setCandidates(paginatedCandidates);
            } catch (error) {
                console.error('Failed to fetch all candidates:', error);
                setCandidates([]);
            } finally {
                setLoading(false);
            }
        };

        fetchAllCandidates();
    }, [currentPage]);

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleContinueToDashboard = () => {
        navigate('/companies/dashboard'); // Navigate to company dashboard
    };

    const handleCandidateClick = (candidate: Candidate) => {
        console.log('Candidate clicked:', candidate);
        // TODO: Navigate to candidate details page or open modal
        // navigate(`/companies/candidates/${candidate.id}`);
    };

    if (loading) {
        return (
            <div className="min-h-screen bg-[#F8F9FB] flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                    <p style={{ fontFamily: 'Manrope', color: '#6B7280' }}>Loading recommendations...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-[#F8F9FB] relative overflow-hidden">
            {/* Background Gradient Layer */}
            <div className="absolute inset-0 overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-full">
                    <div className="absolute top-1/4 left-1/4 w-[600px] h-[400px] bg-gradient-to-br from-blue-300 via-blue-200 to-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-pulse-slow"></div>
                    <div className="absolute top-1/3 right-1/4 w-[500px] h-[500px] bg-gradient-to-br from-yellow-200 via-orange-200 to-pink-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse-slow" style={{animationDelay: '2s'}}></div>
                    <div className="absolute bottom-1/4 left-1/3 w-[400px] h-[400px] bg-gradient-to-br from-pink-200 via-purple-200 to-indigo-200 rounded-full mix-blend-multiply filter blur-3xl opacity-35 animate-pulse-slow" style={{animationDelay: '4s'}}></div>
                </div>
            </div>
            
            {/* Content Layer */}
            <div className="relative z-10 px-4 py-12">
                <div className="max-w-7xl mx-auto">
                    {/* Logo Section */}
                    <div className="mb-12 animate-fade-in-down text-center">
                        <div className="flex justify-center items-center">
                            <img 
                                src="/branding/logo_blue.svg" 
                                alt="Hush" 
                                style={{
                                    width: '164px',
                                    height: '75px',
                                    objectFit: 'contain',
                                    filter: 'brightness(0) saturate(100%) invert(27%) sepia(95%) saturate(1574%) hue-rotate(212deg) brightness(91%) contrast(101%)'
                                }}
                            />
                        </div>
                    </div>

                    {/* Candidates Grid - 3x3 Layout */}
                    <div 
                        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12 animate-fade-in-up"
                        style={{ animationDelay: '0.2s' }}
                    >
                        {candidates.map((candidate, index) => (
                            <CandidateMatchCard 
                                key={candidate.id}
                                candidate={candidate}
                                animationDelay={0.4 + (index * 0.1)}
                                onClick={handleCandidateClick}
                            />
                        ))}
                    </div>

                    {/* Empty State */}
                    {candidates.length === 0 && !loading && (
                        <div className="text-center py-12">
                            <p style={{ fontFamily: 'Manrope', color: '#6B7280', fontSize: '18px' }}>
                                No candidates found.
                            </p>
                        </div>
                    )}

                    {/* Pagination Controls */}
                    {totalPages > 1 && (
                        <div 
                            className="flex items-center justify-center gap-4 mb-8 animate-fade-in-up"
                            style={{ animationDelay: '0.8s' }}
                        >
                            <button
                                onClick={handlePreviousPage}
                                disabled={currentPage === 1}
                                style={{
                                    width: '44px',
                                    height: '44px',
                                    borderRadius: '8px',
                                    border: '1px solid #D1D5DB',
                                    background: currentPage === 1 ? '#F9FAFB' : '#FFFFFF',
                                    color: currentPage === 1 ? '#9CA3AF' : '#374151',
                                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                    if (currentPage !== 1) {
                                        e.currentTarget.style.background = '#F3F4F6';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (currentPage !== 1) {
                                        e.currentTarget.style.background = '#FFFFFF';
                                    }
                                }}
                            >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" stroke="currentColor"/>
                                </svg>
                            </button>

                            <button
                                onClick={handleNextPage}
                                disabled={currentPage === totalPages}
                                style={{
                                    width: '44px',
                                    height: '44px',
                                    borderRadius: '8px',
                                    border: '1px solid #D1D5DB',
                                    background: currentPage === totalPages ? '#F9FAFB' : '#2563EB',
                                    color: currentPage === totalPages ? '#9CA3AF' : '#FFFFFF',
                                    cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                    if (currentPage !== totalPages) {
                                        e.currentTarget.style.background = '#1D4ED8';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (currentPage !== totalPages) {
                                        e.currentTarget.style.background = '#2563EB';
                                    }
                                }}
                            >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" stroke="currentColor"/>
                                </svg>
                            </button>
                        </div>
                    )}

                    {/* Continue to Dashboard Button */}
                    <div 
                        className="flex justify-center animate-fade-in-up"
                        style={{ animationDelay: '1.0s' }}
                    >
                        <button
                            onClick={handleContinueToDashboard}
                            style={{
                                fontFamily: 'Manrope',
                                fontWeight: 600,
                                fontSize: '16px',
                                color: '#FFFFFF',
                                background: '#2563EB',
                                border: 'none',
                                borderRadius: '12px',
                                padding: '16px 32px',
                                cursor: 'pointer',
                                boxShadow: '0px 8px 24px rgba(37, 99, 235, 0.4)',
                                transition: 'all 0.3s ease',
                                minWidth: '200px'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = '#1D4ED8';
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0px 12px 32px rgba(37, 99, 235, 0.5)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = '#2563EB';
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0px 8px 24px rgba(37, 99, 235, 0.4)';
                            }}
                        >
                            Continue to Dashboard
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllRecommendations;
